import React, { useEffect } from "react";
import GrossIncome from "../../components/ReportsAnalytics/GrossIncome";
import ProdTable from "../../components/ReportsAnalytics/ProdTable";
import Transactions from "../../components/ReportsAnalytics/Transactions";

const GiftCardDetails = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="d-flex flex-column justify-content-start py-4 px-4 bg-light">
        <div className="d-flex align-items-center gap-3 py-2">
          <span className="font-40 font-bold mb-2">Gift card details</span>
        </div>

        <div className="d-flex flex-column gap-2">

        <div className="d-flex">
        <ProdTable />
      </div>
      <div className="d-flex">
        <GrossIncome />
      </div>

      <div className="d-flex">
        <Transactions />
      </div>
      </div>

    </div>
  );
};

export default GiftCardDetails;
